import {createUseStyles} from 'react-jss';

export default createUseStyles({
  labelWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 'inherit',
    marginLeft: 0,
    position: 'relative', // Fixes placement of * before field labels that are not aligned left
    // field-unit-1
    width: 'auto',
    // m-unit-1
    marginRight: '1em',
  },
});
